import { Alert } from "./alert";
export * from "./alert";
export var ALERT_DIRECTIVES = [
    Alert
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/emphasis/alert/index.js
// module id = 181
// module chunks = 4